import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomErrorComponent, ForbiddenComponent, LoginComponent, LogoutComponent, UnauthorizedComponent, UserLoginComponent } from '@hub/components/v1/authetication';
import { LayoutComponent } from '@hub/components/v1/layout.component';
import { eSystemModule } from './_generated/enums';
import { MainRedirectComponent } from './components/v1/_common/main-redirect.component';
import { SyncBookingComponent } from './components/v1/_common/sync-booking.component';
import { AuthGuard } from './guards/auth.guard';
import { UserSystemModuleGuard } from './guards/user-system-module.guard';
import { UserResolver } from './resolvers/UserResolver';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'main' },
  { path: 'null', pathMatch: 'full', redirectTo: 'main' },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'forbidden', component: ForbiddenComponent },
  { path: 'userlogin', component: UserLoginComponent },
  {
    path: '', component: LayoutComponent,
    canActivate: [AuthGuard],
    resolve: { user: UserResolver },
    children: [
      { path: 'main',
        component: MainRedirectComponent
      },
      { path: 'sync-booking',
        component: SyncBookingComponent
      },
      { path: 'users',
        loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule),
        canActivate: [UserSystemModuleGuard],
        data: { systemModule: [eSystemModule.HUBContacts_Users ] }
      },
      { path: 'tv10bookings',
        loadChildren: () => import('./modules/tv10/tv10.module').then(m => m.Tv10Module),
        canActivate: [UserSystemModuleGuard],
        data: { systemModule: [eSystemModule.HUBTv10Percent_Tv10Percent ] }
      },
      { path: 'packages',
        loadChildren: () => import('./modules/tv-packages/tv-packages.module').then(m => m.TvPackagesModule),
        canActivate: [UserSystemModuleGuard],
        data: { systemModule: [eSystemModule.HUBTvPackages_TvPackages ] }
      },
    ]
  },
  {
    path: '**',
    component: CustomErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
